import { Box, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { UserAPI } from '../../../../features/users/services/user-api';
import UserAvatar from '../../../components/user-avatar';

export type UserProfileSectionProps = {
  showUserName?: boolean;
  profileRoute?: string;
  className?: string;
};

/**
 * User Profile Section Component
 * Displays user avatar and name with link to profile page
 */
const UserProfileSection = ({
  showUserName = false,
  profileRoute = '/perfil/usuario',
  className
}: UserProfileSectionProps) => {
  const currentUser = UserAPI.getCurrentUser();

  return (
    <Link to={profileRoute} style={{ textDecoration: 'none', color: 'inherit' }} className={className}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}>
        {showUserName && (
          <Typography component="p" variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
            <strong>Bienvenido {currentUser?.name ?? ''}</strong>
          </Typography>
        )}
        <UserAvatar user={currentUser} size={32} />
      </Box>
    </Link>
  );
};

export default UserProfileSection;
